import Mock from "mockjs";

Mock.mock("/api/project", "get", {
  code: 0,
  msg: "",
  "data|10-20": [
    {
      id: "@guid",
      name: "@ctitle(5,6)",
      url: Mock.Random.url(),
      "github|1": [Mock.Random.url(), null],
      "description|1-4": ["@csentence(40, 140)"],
      "thumb|1": ["@image(300x250, @color, #fff, @natural)"],
      "order|+1": 1,
    },
  ],
});
